/* eslint-disabled */

export default class LanguageExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
